import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  Button,
  Space,
  Input,
  Select,
  Popconfirm,
  message,
  Tag,
  Typography,
  Divider,
  Col,
  Row,
} from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import MoneyInput from "./MoneyInput";
import axios from "axios";
import {
  GET_LOAD_PAYFORS,
  HEADERS_EXPORT_BEN,
  POST_UPDATE_PAYFORS,
} from "../../../API/apiUrls";

const { Text } = Typography;

// ── รายการคงที่ 3 ตัว (ลบไม่ได้) ────────────────────────────
const FIXED_ITEMS = [
  { key: "courtFee", PAYFOR: "333", label: "ค่าฤชาศาล", fieldName: "courtFee" },
  {
    key: "trackingFee",
    PAYFOR: "111",
    label: "ค่าติดตาม",
    fieldName: "trackingFeeEnforce",
  },
  {
    key: "lawyerFee",
    PAYFOR: "222",
    label: "ค่าทนายความ",
    fieldName: "lawyerFeeEnforce",
  },
];

// PAYFOR ที่คำนวณอัตโนมัติ → ไม่แสดงในส่วนนี้
const AUTO_PAYFORS = new Set(["111", "222", "333", "444", "555"]);

const CourtOrderedCosts = ({
  form,
  tabNumber = 1,
  arothrData = [],
  extraCostsFromTab1 = [], // ✅ เพิ่ม prop
  idJudge,
  contno,
  userName,
  onCostsChange,
}) => {
  const suffix = tabNumber === 1 ? "1" : "2";

  const [extraCosts, setExtraCosts] = useState([]);
  const [addingNew, setAddingNew] = useState(false);
  const [newLabel, setNewLabel] = useState("");
  const [selectedForcode, setSelectedForcode] = useState(null);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [availableCodes, setAvailableCodes] = useState([]);

  // ── โหลดรายการเพิ่มเติมจาก arothrData (ครั้งแรก) ─────────
  useEffect(() => {
    console.log("1");

    if (!arothrData || arothrData.length === 0) return;

    const extras = arothrData
      .filter((item) => !AUTO_PAYFORS.has(item.PAYFOR))
      .map((item) => ({
        ARCONT: item.ARCONT,
        PAYFOR: item.PAYFOR,
        label: item.FORDESC || `รายการ ${item.PAYFOR}`,
        amount: parseFloat(item.PAYAMT) || 0,
        fieldName: `extraCost_${item.PAYFOR}_${suffix}`,
      }));

    setExtraCosts(extras);

    const formValues = {};
    extras.forEach((item) => {
      formValues[item.fieldName] = item.amount || null;
    });
    form.setFieldsValue(formValues);
  }, [arothrData, form, suffix]);

  // ── Notify parent เมื่อรายการเปลี่ยน ─────────────────────
  useEffect(() => {
    console.log("2");
    onCostsChange?.(extraCosts);
  }, [extraCosts, onCostsChange]);

  useEffect(() => {
    console.log("3");
    if (tabNumber !== 2) return;
    if (!extraCostsFromTab1 || extraCostsFromTab1.length === 0) return;

    const syncedExtras = extraCostsFromTab1.map((item) => ({
      ...item,
      fieldName: `extraCost_${item.PAYFOR}_2`,
    }));

    setExtraCosts(syncedExtras);

    const formValues = {};
    syncedExtras.forEach((item) => {
      const tab1Value = form.getFieldValue(`extraCost_${item.PAYFOR}_1`);
      formValues[item.fieldName] = tab1Value ?? item.amount ?? null;
    });
    form.setFieldsValue(formValues);
  }, [tabNumber, extraCostsFromTab1, form]);

  // ── เรียก API ดึง FORCODE ที่ใช้ได้ ───────────────────────
  const loadForsCodes = useCallback(async () => {
    setLoadingAdd(true);
    try {
      const res = await axios.get(GET_LOAD_PAYFORS, {
        headers: HEADERS_EXPORT_BEN,
      });

      const allCodes = res.data?.data || [];

      const usedPayfors = new Set([
        ...AUTO_PAYFORS,
        ...extraCosts.map((e) => e.PAYFOR),
        ...arothrData.map((a) => a.PAYFOR),
      ]);

      const unused = allCodes.filter((code) => !usedPayfors.has(code.FORCODE));
      setAvailableCodes(unused);

      if (unused.length === 0) {
        message.warning("ไม่มีรหัสรายการที่ใช้ได้แล้ว");
        return false;
      }

      setSelectedForcode(unused[0].FORCODE);
      setNewLabel(unused[0].FORDESC || "");
      return true;
    } catch (error) {
      message.error(error?.response?.data?.message || "ไม่สามารถโหลดข้อมูลได้");
      return false;
    } finally {
      setLoadingAdd(false);
    }
  }, [extraCosts, arothrData]);

  // ── POST รายการใหม่ขึ้น API ───────────────────────────────
  const postForsCodes = useCallback(
    async (forcode, fordesc) => {
      // setLoadingAdd(true);
      const payload = {
        FORCODE: forcode,
        FORDESC: fordesc,
      };
      console.log("payload", payload);
      // เช็คซ้ำ ชื่อรายการ (รวม extraCosts + availableCodes)
      const trimmedLabel = fordesc.trim().toLowerCase();
      const isDuplicateLabel =
        extraCosts.some((e) => e.label.toLowerCase() === trimmedLabel) ||
        availableCodes.some((c) => c.FORDESC?.toLowerCase() === trimmedLabel);
      if (isDuplicateLabel) {
        message.warning(`ชื่อรายการ "${newLabel.trim()}" มีอยู่แล้ว`);
        return;
      }

      try {
        const res = await axios.post(POST_UPDATE_PAYFORS, payload, {
          headers: HEADERS_EXPORT_BEN,
        });
        if (res.status === 201) {
          await loadForsCodes(); // โหลดใหม่หลัง post สำเร็จ
          return true;
        }
        return false;
      } catch (error) {
        message.error(
          error?.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้",
        );
        return false;
      } finally {
        setLoadingAdd(false);
      }
    },
    [loadForsCodes],
  );

  // ── กดปุ่ม "เพิ่มลูกหนี้อื่นๆ" ──────────────────────────
  const handleOpenAdd = useCallback(async () => {
    const ok = await loadForsCodes();
    if (ok) {
      setAddingNew(true);
    }
  }, [loadForsCodes]);

  // ── เลือก FORCODE จาก dropdown ────────────────────────────
  const handleSelectForcode = useCallback(
    (forcode) => {
      setSelectedForcode(forcode);
      if (forcode === "0") {
        // custom → ล้าง label ให้กรอกเอง
        setNewLabel("");
        return;
      }
      const found = availableCodes.find((c) => c.FORCODE === forcode);
      setNewLabel(found?.FORDESC || "");
    },
    [availableCodes],
  );

  // ── คำนวณ FORCODE ถัดไป ───────────────────────────────────
  const getNextForcode = useCallback(() => {
    const allNums = [
      ...availableCodes.map((c) => parseInt(c.FORCODE, 10)),
      ...extraCosts.map((e) => parseInt(e.PAYFOR, 10)),
    ].filter((n) => !isNaN(n));

    const maxNum = allNums.length > 0 ? Math.max(...allNums) : 0;
    return String(maxNum + 1).padStart(3, "0");
  }, [availableCodes, extraCosts]);

  // ── กดยืนยัน "เพิ่ม" ─────────────────────────────────────
  const handleAddCost = useCallback(async () => {
    if (!newLabel?.trim()) return message.warning("กรุณาระบุชื่อรายการ");
    if (!selectedForcode) return message.warning("กรุณาเลือกรหัสรายการ");

    const resolvedForcode =
      selectedForcode === "0" ? getNextForcode() : selectedForcode;

    // เช็คซ้ำใน extraCosts
    const isDuplicate = extraCosts.some((e) => e.PAYFOR === resolvedForcode);
    if (isDuplicate) {
      message.warning(`รหัส ${resolvedForcode} ถูกเพิ่มไปแล้ว`);
      return;
    }

    // ── เช็คว่ามีใน availableCodes มั้ย ──────────────────────
    const existsInApi = availableCodes.some(
      (c) => c.FORCODE === resolvedForcode,
    );

    if (!existsInApi) {
      message.loading({ content: "กำลังบันทึกรายการใหม่...", key: "posting" });
      const ok = await postForsCodes(resolvedForcode, newLabel.trim());
      if (!ok) {
        message.error({ content: "บันทึกไม่สำเร็จ", key: "posting" });
        return;
      }
      message.success({ content: "บันทึกรายการใหม่สำเร็จ", key: "posting" });
    }

    // ── เพิ่มเข้า form ────────────────────────────────────────
    const fieldName = `extraCost_${resolvedForcode}_${suffix}`;
    const newItem = {
      ARCONT: null,
      PAYFOR: resolvedForcode,
      label: newLabel.trim(),
      amount: 0,
      fieldName,
    };

    setExtraCosts((prev) => [...prev, newItem]);
    form.setFieldsValue({ [fieldName]: null });

    setNewLabel("");
    setSelectedForcode(null);
    setAddingNew(false);
    message.success(`เพิ่ม "${newLabel.trim()}" (${resolvedForcode}) สำเร็จ`);
  }, [
    selectedForcode,
    newLabel,
    extraCosts,
    suffix,
    form,
    getNextForcode,
    availableCodes,
    postForsCodes,
  ]);

  // ── ลบรายการ ──────────────────────────────────────────────
  const handleRemoveCost = useCallback(
    (payfor) => {
      const fieldName = `extraCost_${payfor}_${suffix}`;
      setExtraCosts((prev) => prev.filter((item) => item.PAYFOR !== payfor));
      form.setFieldsValue({ [fieldName]: null });
    },
    [form, suffix],
  );

  return (
    <>
      <Divider orientation="left">💵 ศาลสั่งให้ต้องจ่าย</Divider>

      {/* ── รายการคงที่ ────────────────────────────────────── */}
      {FIXED_ITEMS.map((item) => {
        const fieldFullName = `${item.fieldName}${suffix}`;
        console.log("fieldFullName", fieldFullName);

        return (
          <Form.Item key={item.key} label={item.label}>
            <Form.Item name={fieldFullName} noStyle>
              <MoneyInput
                placeholder="ไม่มีไม่ต้องกรอก"
                style={{ width: "40%" }}
              />
            </Form.Item>
          </Form.Item>
        );
      })}

      {/* ── รายการเพิ่มเติม (จาก DB + เพิ่มใหม่) ─────────── */}
      {extraCosts.map((item) => (
        <Form.Item
          key={item.PAYFOR}
          label={<Space size={4}>{item.label}</Space>}
        >
          {console.log("item", item)}
          <Space>
            <Form.Item name={item.fieldName} noStyle>
              <MoneyInput placeholder="ไม่มีไม่ต้องกรอก" />
            </Form.Item>
            <Popconfirm
              title="ลบรายการนี้?"
              description={`"${item.label}" จะถูกลบออก`}
              onConfirm={() => handleRemoveCost(item.PAYFOR)}
              okText="ลบ"
              cancelText="ยกเลิก"
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Popconfirm>
          </Space>
        </Form.Item>
      ))}

      {/* ── ปุ่มเพิ่ม / ฟอร์มเพิ่ม ────────────────────────── */}
      {!addingNew ? (
        <Row gutter={24} align="end">
          <Col span={24}>
            <Form.Item label=":">
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={handleOpenAdd}
                loading={loadingAdd}
                style={{ borderColor: "#1890ff", color: "#1890ff" }}
              >
                เพิ่มลูกหนี้อื่นๆ
              </Button>
            </Form.Item>
          </Col>
        </Row>
      ) : (
        <Form.Item label=":">
          <div
            style={{
              background: "#fafafa",
              border: "1px dashed #d9d9d9",
              borderRadius: 8,
              padding: 16,
              maxWidth: 500,
            }}
          >
            <Text strong style={{ display: "block", marginBottom: 12 }}>
              เพิ่มรายการใหม่
            </Text>
            <Space direction="vertical" style={{ width: "100%" }} size={12}>
              {/* ── เลือกรหัส ──────────────────────────────── */}
              <div>
                <Text
                  type="secondary"
                  style={{ fontSize: 12, display: "block", marginBottom: 4 }}
                >
                  เลือกรหัสรายการ
                </Text>
                <Select
                  value={selectedForcode}
                  onChange={handleSelectForcode}
                  size="large"
                  style={{ width: "100%" }}
                  placeholder="เลือกรหัส"
                  options={[
                    ...availableCodes.map((c) => ({
                      value: c.FORCODE,
                      label: `${c.FORCODE} — ${c.FORDESC}`,
                    })),
                    {
                      value: "0",
                      label: "➕ เพิ่มรายการใหม่ (กำหนดเอง)",
                    },
                  ]}
                />
              </div>

              {/* ── ชื่อรายการ ─────────────────────────────── */}
              <div>
                <Text
                  type="secondary"
                  style={{ fontSize: 12, display: "block", marginBottom: 4 }}
                >
                  ชื่อรายการ
                  {selectedForcode === "0" && (
                    <Tag color="blue" style={{ marginLeft: 8 }}>
                      รหัสใหม่: {getNextForcode()}
                    </Tag>
                  )}
                </Text>
                <Input
                  placeholder='เช่น "ค่าเสียหาย" "ค่าปรับ"'
                  value={newLabel}
                  onChange={(e) => setNewLabel(e.target.value)}
                  onPressEnter={handleAddCost}
                  size="large"
                  // แก้ไขได้เฉพาะเมื่อเป็น custom
                  disabled={selectedForcode !== "0"}
                />
              </div>

              <Space>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleAddCost}
                  loading={loadingAdd}
                >
                  เพิ่ม
                </Button>
                <Button
                  onClick={() => {
                    setAddingNew(false);
                    setNewLabel("");
                    setSelectedForcode(null);
                  }}
                >
                  ยกเลิก
                </Button>
              </Space>
            </Space>
          </div>
        </Form.Item>
      )}
    </>
  );
};

export default CourtOrderedCosts;
